import {
  Badge,
  type BadgeVariant,
  InlineLink,
  TextCaption,
  Typography,
  type TypographyProps,
} from '@carboncopyco/ui';
import type { ReactElement } from 'react';

type FeatureCardProps = {
  title: string;
  description: TypographyProps['label'];
  illustration: ReactElement;
  goToFeaturePage: () => void;
  badgeLabel: string;
  badgeVariant?: BadgeVariant;
};

export const FeatureCard = ({
  title,
  description,
  illustration,
  goToFeaturePage,
  badgeLabel,
  badgeVariant = 'blue',
}: FeatureCardProps) => {
  return (
    <div className="rounded-md h-36 bg-ds-primary-200 p-4 flex justify-between">
      <div className="flex flex-col items-start justify-between ">
        <div>
          <Badge
            variant={badgeVariant}
            label={badgeLabel.toUpperCase()}
          />
          <div className="pt-3">
            <Typography
              color="text-ds-accent3-100"
              label={title}
              tagName="p"
              fontSize="text-ds-300"
              fontWeight="font-ds-medium"
            />
          </div>
          <div className="pt-1">
            <TextCaption
              tagName="p"
              color="text-ds-accent3-100"
              label={description}
              lineHeight="leading-ds-200"
            />
          </div>
        </div>
        <InlineLink
          fontSize="text-ds-200"
          onClick={() => {
            goToFeaturePage();
          }}
          color="text-ds-accent3-100"
          label="Visit page"
        />
      </div>
      <div className="self-end">{illustration}</div>
    </div>
  );
};
